import { FlagsmithProvider } from '@flagsmith/flagsmith/react';
import flagsmith from '@flagsmith/flagsmith';
import { IonApp, IonLoading } from '@ionic/react';
import './App.css';
import '@ionic/core/css/core.css';
import '@ionic/core/css/ionic.bundle.css';
import './Styling.css';
import AppRouter from './components/AppRouter';
import InternetConnectionStatus from './contexts/InternetConnectionStatusContext';
import ApiContainer from './contexts/ApiContext';
import PushNotifications from './contexts/PushNotificationsContext';
import { UpgradePrompt } from './components/UpgradePrompt';
import { ServiceWorkerProvider } from './contexts/ServiceWorkerProvider';
import { Auth } from './authentication/Auth';
import { isTest } from './utilities/api';
import { AuthenticationFeatureSwitch, useKeycloakAuthFlagName } from './authentication/AuthenticationFeatureSwitch';
import { PermissionProvider } from "./authorisation/PermissionProvider";

const flagsmithEnvironmentID = process.env.REACT_APP_FLAGSMITH_ENV_ID;
const flagsmithOptions = {
    environmentID: flagsmithEnvironmentID,
    cacheFlags: !isTest(),
    defaultFlags: {
        [useKeycloakAuthFlagName]: {
            enabled: process.env.REACT_APP_AUTH_MODE === 'keycloak',
        },
    },
};

export default function App() {
    return (
        <FlagsmithProvider
            flagsmith={ flagsmith }
            options={ flagsmithOptions }
        >
            <AuthenticationFeatureSwitch>
                <ServiceWorkerProvider>
                    <IonApp>
                        <UpgradePrompt />
                        <Auth
                            fallback={ () => (<IonLoading
                                    isOpen
                                    message="Loading..."
                                    spinner="crescent"
                                />) }
                        >
                            <PermissionProvider>
                                <InternetConnectionStatus>
                                    <PushNotifications>
                                        <ApiContainer>
                                            <AppRouter />
                                        </ApiContainer>
                                    </PushNotifications>
                                </InternetConnectionStatus>
                            </PermissionProvider>
                        </Auth>
                    </IonApp>
                </ServiceWorkerProvider>
            </AuthenticationFeatureSwitch>
        </FlagsmithProvider>
    );
}
